// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Introduce_style_wrap__2Z5y7","title":"Introduce_style_title__1NiEQ","grey":"Introduce_style_grey__34D1R"};